interface HyperlinkProps {
  href?: string;
  children: React.ReactNode;
  className?: string;
}

const ExternalLinkIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    className="inline-block ml-1 mb-1"
    xmlns="http://www.w3.org/2000/svg"
    data-rtl-flip=""
  >
    <path d="M11.3349 10.3301V5.60547L4.47065 12.4707C4.21095 12.7304 3.78895 12.7304 3.52925 12.4707C3.26955 12.211 3.26955 11.789 3.52925 11.5293L10.3945 4.66504H5.66011C5.29284 4.66504 4.99507 4.36727 4.99507 4C4.99507 3.63273 5.29284 3.33496 5.66011 3.33496H11.9999L12.1337 3.34863C12.4369 3.41057 12.665 3.67857 12.665 4V10.3301C12.6649 10.6973 12.3672 10.9951 11.9999 10.9951C11.6327 10.9951 11.335 10.6973 11.3349 10.3301ZM11.333 4.66699L11.3349 4.66797L11.332 4.66504H11.331L11.333 4.66699Z"></path>
  </svg>
);

const Hyperlink: React.FC<HyperlinkProps> = ({
  href,
  children,
  className = "",
}) => {
  if (!href) {
    return <span className={className}>{children}</span>;
  }

  return (
    <a
      href={href}
      className={`inline-flex items-center font-medium text-blue-600 hover:text-blue-800 transition-colors duration-200 ${className}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
      <ExternalLinkIcon />
    </a>
  );
};

export default Hyperlink;
